import AspApi from "api/ApiConfig";

// NEW - INBOX

export const inboxList = async (params) => {
  let qpm = [];

  if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
  if (params?.businessPhoneNumber)
    qpm.push(`business_phone_number=${params?.businessPhoneNumber}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.conversation) qpm.push(`conversation=${params?.conversation}`);
  if (params?.inbox_filter) qpm.push(`inbox_filter=${params?.inbox_filter}`);
  if (params?.favourite) qpm.push(`favourite=${params?.favourite}`);
  if (params?.unassigned) qpm.push(`unassigned=${params?.unassigned}`);
  if (params?.user_id) qpm.push(`user_id=${params?.user_id}`);
  if (params?.search) qpm.push(`search=${params?.search}`);
  if (params?.tag_id) qpm.push(`tag_id=${params?.tag_id}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);
  if (params?.campaign_id) qpm.push(`campaign_id=${params?.campaign_id}`);
  if (params?.include_broadcasts) qpm.push(`include_broadcasts=${params?.include_broadcasts}`);
  if (params?.include_sequences) qpm.push(`include_sequences=${params?.include_sequences}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(`api/v1/svc/inbox/inbox${qpmString}`);
  return res;
};

export const updateAgentEngagementStatus = async (params) => {
  const res = await AspApi.put(`api/v1/svc/inbox/inbox_utils/agent_engagement_status`, params);
  return res;
}

// export const inboxListCounts = async (params) => {
//   let qpm = [];

//   if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
//   let qpmString = "";

//   if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

//   const res = await AspApi.get(
//     `api/v1/svc/inbox/inbox/conversation_count${qpmString}`
//   );
//   return res;
// };

export const inboxListCounts = async (id) =>
  await AspApi.get(`api/v1/svc/inbox/inbox/conversation_count?brand_id=${id}`);

export const inboxCustomerJourney = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1/svc/inbox/inbox_utils/customer_journey${qpmString}`
  );
  return res;
};

export const inboxAttachments = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.attachment_type) qpm.push(`attachment_type=${params?.attachment_type}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1/svc/inbox/inbox_utils/attachments${qpmString}`
  );
  return res;
};

export const inboxNotes = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    // `api/v1/svc/inbox/inbox_utils/attachments${qpmString}`
    `api/v1/svc/inbox/notes${qpmString}`
  );
  return res;
};

export const createNote = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/notes`, payLoad
  );
  return res;
};

export const updateNote = async (payLoad) => {
  const res = await AspApi.put(
    `api/v1/svc/inbox/notes/${payLoad.tag_id}`, payLoad
  );
  return res;
};

export const deleteNote = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.delete(
    // api/v1/svc/inbox/notes/:id?contact_conversation_id=5&brand_id=1
    `api/v1/svc/inbox/notes/${params.note_id}${qpmString}`
  );
  return res;
};

export const inboxFavourite = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/inbox_utils/add_favourite`,
    payLoad
  );
  return res;
};

// Get Quick Replies
export const inboxQuickReplies = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1/svc/inbox/quick_reply${qpmString}`
  );
  return res;
};

// Create Quick Reply
export const inboxCreateQuickReply = async (params) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/quick_reply`,
    params
  );
  return res;
};

// Update Quick Reply
export const inboxUpdateQuickReply = async (params, bodyParams) => {
  const res = await AspApi.put(
    `api/v1/svc/inbox/quick_reply/${params?.id}`,
    bodyParams
  );
  return res;
};

// Delete Quick Reply
export const inboxDeleteQuickReply = async (params) => {
  let qpm = [];

  if (params?.brand_id) qpm.push(`brand_id=${params?.brand_id}`);
  if (params?.quick_reply_id) qpm.push(`quick_reply_id=${params?.quick_reply_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");
  const res = await AspApi.delete(
    `api/v1/svc/inbox/quick_reply/${params?.id}${qpmString}`,
  );
  return res;
};

export const inboxResolved = async (payLoad) => {
  const res = await AspApi.put(
    `api/v1/svc/inbox/inbox_utils/conversation_resolved`,
    payLoad
  );
  return res;
};

export const markAsUnread = async (payLoad) => {
  const res = await AspApi.put(
    // `api/v1/svc/inbox/inbox_utils/conversation_resolved`,
    // api/v1/svc/inbox/inbox_utils/mark_as_unread?brand_id=1&contact_conversation_id=5
    `api/v1/svc/inbox/inbox_utils/mark_as_unread`,
    payLoad
  );
  return res;
};

export const markAsRead = async (payLoad) => {
  const res = await AspApi.put(
    `api/v1/svc/inbox/inbox_utils/mark_as_read`,
    payLoad
  );
  return res;
};

export const inboxResolvedReopen = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/inbox_utils/open_resolved_conversation`,
    payLoad
  );
  return res;
};

export const createConversationInbox = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/inbox_utils/create_conversation`,
    payLoad
  );
  return res;
};

export const conversationsView = async (params) => {
  let qpm = [];
  if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
  // if (params?.businessPhoneNumber)
  //   qpm.push(`business_phone_number=${params?.businessPhoneNumber}`);
  // if (params?.customerPhoneNumber)
  //   qpm.push(`customer_phone_number=${params?.customerPhoneNumber}`);
  if (params?.page) qpm.push(`page=${params?.page}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.since) qpm.push(`since=${params?.since}`);
  if (params?.contact_conversation_id)
    qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/conversations/show_conversation${qpmString}`
  );
  return res;
};

export const OpenedConverstationNumbersList = async (params) => {
  let qpm = [];

  if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
  if (params?.businessPhoneNumber)
    qpm.push(`business_phone_number=${params?.businessPhoneNumber}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");
  const res = await AspApi.get(
    `api/v1/svc/inbox/whatsapp_inbox/open_conversation${qpmString}`
  );
  return res;
};

export const ClosedConverstationNumbersList = async (params) => {
  let qpm = [];

  if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
  if (params?.businessPhoneNumber)
    qpm.push(`business_phone_number=${params?.businessPhoneNumber}`);
  if (params?.limit) qpm.push(`limit=${params?.limit}`);
  if (params?.page) qpm.push(`page=${params?.page}`);

  let qpmString = "";

  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  const res = await AspApi.get(
    `api/v1//svc/inbox/whatsapp_inbox/closed_conversation${qpmString}`
  );
  return res;
};

export const whatsappBusinessNumbers = async (brandId, payLoad = {}) => {
  if (!brandId) {
    throw new Error('brandId is required');
  }
  let qpm = [];
  qpm.push(`brand_id=${brandId}`);
  if (payLoad?.call_meta === 'false') qpm.push(`call_meta=${payLoad?.call_meta}`);
  if (payLoad?.search) qpm.push(`search=${payLoad?.search}`);
  if (payLoad?.limit) qpm.push(`limit=${payLoad?.limit}`);
  if (payLoad?.page) qpm.push(`page=${payLoad?.page}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");
  const res = await AspApi.get(
    `/api/v1/svc/whatsapp/whatsapp_numbers${qpmString}`
  );
  return res;
};

// export const conversations = async (params) => {
//   let qpm = [];
//   if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
//   if (params?.businessPhoneNumber)
//     qpm.push(`business_phone_number=${params?.businessPhoneNumber}`);
//   if (params?.customerPhoneNumber)
//     qpm.push(`customer_phone_number=${params?.customerPhoneNumber}`);
//   if (params?.page) qpm.push(`page=${params?.page}`);
//   if (params?.limit) qpm.push(`limit=${params?.limit}`);

//   let qpmString = "";

//   if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

//   const res = await AspApi.get(
//     `/api/v1/svc/whatsapp/conversations/show_conversation${qpmString}`
//   );
//   return res;
// };

export const sendTemplateMessage = async (params) => {
  // query params
  // let qpm = [];
  // if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
  // if (params?.metaTemplateId)
  //   qpm.push(`meta_template_id=${params?.metaTemplateId}`);

  // let qpmString = "";
  // if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  // body params
  let bodyParams = {};
  if (params?.sendFrom) bodyParams["from_number"] = params?.sendFrom;
  if (params?.sendTo) bodyParams["to_number"] = params?.sendTo;
  if (params?.brandId) bodyParams["brand_id"] = params?.brandId;
  if (params?.metaTemplateId)
    bodyParams["template_id"] = params?.metaTemplateId;
  if (params?.contact_conversation_id)
    bodyParams["contact_conversation_id"] = params?.contact_conversation_id;
  if (params?.subcategory_type)
    bodyParams["subcategory_type"] = params?.subcategory_type;
  if (params?.category)
    bodyParams["category"] = params?.category;
  if (params?.variables) bodyParams["variables"] = params?.variables;
  if (params?.payment_details) bodyParams["payment_details"] = params?.payment_details;

  const res = await AspApi.post(
    `api/v1/svc/whatsapp/conversations/send_template`,
    bodyParams
  );
  return res;
};

export const sendTextMessage = async (params) => {
  // query params
  let qpm = [];
  // if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);

  let qpmString = "";
  if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

  // body params
  let bodyParams = {};
  if (params?.brandId) bodyParams["brand_id"] = params?.brandId;
  if (params?.sendFrom) bodyParams["from_number"] = params?.sendFrom;
  if (params?.sendTo) bodyParams["to_number"] = params?.sendTo;
  if (params?.msg) bodyParams["message_body"] = params?.msg;
  if (params?.contact_conversation_id)
    bodyParams["contact_conversation_id"] = params?.contact_conversation_id;
  if (params?.replay_to)
    bodyParams["replay_to"] = params?.replay_to;
    

  const res = await AspApi.post(
    `/api/v1/svc/whatsapp/conversations/send_message${qpmString}`,
    bodyParams
  );
  return res;
};

// Team Members

// export const inboxTeamMembers = async (params) => {
//   let qpm = [];

//   if (params?.brandId) qpm.push(`brand_id=${params?.brandId}`);
//   if (params?.contact_conversation_id) qpm.push(`contact_conversation_id=${params?.contact_conversation_id}`);
//   if (params?.search) qpm.push(`search=${params?.search}`);

//   let qpmString = "";

//   if (qpm?.length > 0) qpmString = "?" + qpm.join("&");

//   const res = await AspApi.get(
//     `api/v1/svc/inbox/inbox_utils/team_members${qpmString}`
//   );
//   return res;
// };

export const inboxTeamMembers = async (brandId, contact_conversation_id, include_current_user=false) => {
  let qpm = [];

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (contact_conversation_id)
    qpm.push(`contact_conversation_id=${contact_conversation_id}`);
  if (include_current_user)
    qpm.push(`include_current_user=${include_current_user}`);

  let qpmString = qpm.length > 0 ? "?" + qpm.join("&") : "";

  const res = await AspApi.get(
    `api/v1/svc/inbox/inbox_utils/team_members${qpmString}`
  );
  return res;
};

export const markMessagesAsRead = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/whatsapp/conversations/read_receipts`,
    payLoad
  );
  return res;
};

export const teamMembersAssign = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/inbox/inbox_utils/set_conversation_assignment`,
    payLoad
  );
  return res;
};

export const inboxTags = async (brandId, contact_conversation_id) => {
  let qpm = [];

  // qpm.push(`limit=5`);

  if (brandId) qpm.push(`brand_id=${brandId}`);
  if (contact_conversation_id)
    qpm.push(`contact_conversation_id=${contact_conversation_id}`);

  let qpmString = qpm.length > 0 ? "?" + qpm.join("&") : "";

  const res = await AspApi.get(
    `/api/v1/svc/contacts/tag/pinned_tag_list${qpmString}`
    // `api/v1/svc/contacts/tag${qpmString}`
  );
  return res;
};

export const addPinnedTags = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/contacts/tag/${payLoad.tag_id}/pin_tag`,
    payLoad
  );
  return res;
};

export const removePinnedTags = async (payLoad) => {
  const res = await AspApi.post(
    `api/v1/svc/contacts/tag/${payLoad.tag_id}/pin_tag`,
    payLoad
  );
  return res;
};